import React from "react";

const Spinner = () => (
  <div className="spinner-border animate-spin inline-block w-4 h-4 border-4 rounded-full text-white"></div>
);

export default Spinner;
